import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { injectStructuredData } from './utils/structuredData';

// Inject structured data after DOM is ready
if (typeof window !== 'undefined') {
  injectStructuredData();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
